// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#login-component{\n\tmin-height: 100vh;\n\twidth: 100%;\n\t/*background-image: url('../assets/images/people.png');*/\n\tbackground-color: #fff;\n}\n\n#login-component #login-form{\n\twidth: 240px;\n\tpadding: 20px;\n\tmargin: auto;\n\tposition: absolute;\n\ttop: 20%;\n\tleft: 0;\n\tright: 0;\n}\n\n#login-component #login-btn{\n\tbackground: #0066B1;\n\tborder-radius: 3px;\n\tcolor: #fff;\n\tborder-color: #0066B1;\n}", ""]);
// Exports
module.exports = exports;
